<div>
  <!--------------------------------------------- Header ------------------------------------->
  <div class="flex flex-col w-full relative">
    <!---------------------------------- กรอกข้อมูล --------------------------------->
    <div class="w-full bg-white dark:bg-gray-800 py-2 pb-4 px-4 m-2 shadow rounded-lg">
      <div class="flex justify-between item-center gap-2 border-b border-gray-300 dark:border-gray-700 pb-2 mb-2">
        <div class="flex justify-center items-center gap-3 my-4">
          <div class="w-6 h-6">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAABeElEQVR4nO3R0U0DAQwEUfcCxdIChaUKamCD+AeJHLrM2Z6RXID3VZmZmZnZgXJ7vXe6z9vLW02KHjTbEegxsx2BHjJ/vPvH+0yENgDfTURoBTARoR3ANISWAJMQ2gJMQWgNMAGhPUB3hBEAnRHGAHRFGAXQEWEcQDeEkQCdEMYCdEEYDdABYTzA1RFWAFwZYQ3ALwj0/rsAfkCg928DkJOO3l8AOnqACMCPEAH2XtHRA0QAfoQIsPeKjh4gAvAjRIC9V3T0ABGAHyEC7L2i++8DV0kAOAHgBIBbC5DmR+8vAB09QATgR4gAx+9ZCSDAOQkAJwDcWY+lydH7C0BHDxAB+BEiwPG7SgLACQAnANxagDQ/en8B6OgBIgA/QgQ4fs9KAAHOSQA4AeDOeixNjt5fADp6gAjAjxAB9l7R0QNEAH6ECLD3io4eIALwI0SAvVd09AARgB8hAuy9oqMHiAD8CBFg7xUdPUAE4EeIAHuvzMzMzKwe7wua0JpBUSg/4wAAAABJRU5ErkJggg=="
              alt="document--v1" />
          </div>
          <p class="text-yellow-300 dark:text-yellow-500 text-lg font-semibold">
            กรอกข้อมูลบัตรจอดรถ
          </p>
        </div>
        <!-------------------------------------------- ปุ่มบันทึก ------------------------------------->
        <div class="flex justify-end mt-4 max-h-10" *ngIf="!isDisableInput">
          <button (click)="onClickSaveCardAdvance()"
            class="px-6 py-2 bg-blue-400 text-white text-sm rounded hover:bg-blue-500">
            บันทึก
          </button>
        </div>
      </div>
      <!--------- สถานที่ ---------->
      <div class="relative pb-3">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          สถานที่ให้บริการลานจอด
        </label>
        <div class="flex gap-2">
          <input type="text" [value]="siteName" readonly [disabled]="isDisableInput"
            class="flex-1 px-3 py-2 text-sm border dark:border-gray-600 rounded-md bg-gray-100 dark:bg-gray-700 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300" />
          <button type="button" *ngIf="!isDisableInput" (click)="showSelectProviderModal = true"
            class="px-4 py-2 bg-red-500 text-white text-sm rounded hover:bg-red-600 whitespace-nowrap rounded-md">
            เลือก
          </button>
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <!--------- ชื่อบัตรจอดรถ ---------->
        <div class="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0 justify-center items-start w-full">
          <div class="w-full md:w-1/2">
            <p class="text-sm text-gray-700 dark:text-gray-300 pb-2">ชื่อบัตรจอดรถ</p>
            <input type="text"
              class="w-full bg-white dark:bg-gray-700 dark:text-gray-200 border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-yellow-200 rounded-lg"
              placeholder="กรุณากรอกชื่อ" [(ngModel)]="cardAdvancePayloadModel.name" [disabled]="isDisableInput"
              (input)="
                  onChangeValidateTextNumber('name', cardAdvancePayloadModel.name)
                " />
            <!-- แจ้งเตือน -->
            <p class="text-red-600 dark:text-red-400 text-xs mt-1"
              *ngIf="isTextNumberValid.where === 'name' && !isTextNumberValid.result">
              กรุณากรอกตัวอักษรให้ถูกต้องที่ไม่ใช่ # $ % _
            </p>
          </div>
          <!--------- ประเภทบัตรจอดรถ ---------->
          <div class="relative w-full md:w-1/2">
            <p class="text-sm text-gray-700 dark:text-gray-300 pb-2">ประเภทบัตรจอดรถ</p>
            <!-- ปุ่มเลือกประเภทบัตรจอดรถ -->
            <div
              class="w-full bg-white dark:bg-gray-700 dark:text-gray-200 border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm rounded-lg focus:outline-none focus:ring focus:ring-yellow-200 cursor-pointer flex justify-between items-center"
              (click)="
                  isDisableInput
                    ? null
                    : (isOpenSelectCDCardType = !isOpenSelectCDCardType)
                ">
              <span ngClass="{{
                    !selectCDCardType.name ? 'text-gray-600 dark:text-gray-400' : 'text-black dark:text-gray-200'
                  }}">
                {{ selectCDCardType.name || "กรุณาเลือกประเภท" }}
              </span>
              <svg *ngIf="!isDisableInput" class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
            <!-- ตัวเลือกประเภทบัตรจอดรถ -->
            <div
              class="absolute left-0 right-0 mt-1 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg shadow z-10"
              *ngIf="isOpenSelectCDCardType">
              <div *ngFor="let item of optionCardTypeID"
                class="px-3 py-2 hover:bg-yellow-100 dark:hover:bg-gray-600 cursor-pointer text-gray-800 dark:text-gray-200"
                (click)="onClickSelectCDCardType(item)">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0 justify-center items-start w-full">
          <!--------- วันที่เริ่มต้น ---------->
          <div class="w-full md:w-1/2">
            <p class="text-sm text-gray-700 dark:text-gray-300 pb-2">วันที่เริ่มต้น</p>
            <app-input [valueIn]="cardAdvancePayloadModel.startDate" [type]="isDisableInput ? 'text' : 'date'"
              *ngIf="!isDisableInput" [placeholder]="'กรุณากรอกวันที่เริ่มต้น'"
              (valueOut)="cardAdvancePayloadModel.startDate = $event"></app-input>
            <!-- แสดงตัวหนังสืออย่างเดียว -->
            <div
              class="w-full p-2 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700"
              *ngIf="isDisableInput">
              <p class="text-gray-600 dark:text-gray-300">{{ cardAdvancePayloadModel.startDate | date : "dd/MM/yyyy" }}
              </p>
            </div>
          </div>
          <!--------- วันที่สิ้นสุด ---------->
          <div class="w-full md:w-1/2">
            <p class="text-sm text-gray-700 dark:text-gray-300 pb-2">วันที่สิ้นสุด</p>
            <app-input [valueIn]="cardAdvancePayloadModel.endDate" [type]="'date'" *ngIf="!isDisableInput"
              [disabled]="isDisableInput" [placeholder]="'กรุณากรอกวันที่สิ้นสุด'"
              (valueOut)="cardAdvancePayloadModel.endDate = $event"></app-input>
            <!-- แสดงตัวหนังสืออย่างเดียว -->
            <div
              class="w-full p-2 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700"
              *ngIf="isDisableInput">
              <p class="text-gray-600 dark:text-gray-300">{{ cardAdvancePayloadModel.endDate | date : "dd/MM/yyyy" }}
              </p>
            </div>
          </div>
        </div>
        <div class="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0 justify-center items-start w-full">
          <!--------- จํานวนบัตร ---------->
          <div class=" w-full md:w-1/2">
            <p class="text-sm text-gray-700 dark:text-gray-300 pb-2">จํานวนบัตร</p>
            <input type="number"
              class="w-full bg-white dark:bg-gray-700 dark:text-gray-200 border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-yellow-200 rounded-lg"
              placeholder="กรุณากรอกจำนวนบัตร" [disabled]="isDisableInput" [(ngModel)]="cardAdvancePayloadModel.qty"
              max="1000" min="1" />
            <!-- แจ้งเตือน -->
          </div>

          <!--------- ลูกค้า ---------->
          <div class="relative w-full md:w-1/2">
            <p class="text-sm text-gray-700 dark:text-gray-300 pb-2">ลูกค้า</p>
            <!-- ปุ่มเลือกประเภทบัตรจอดรถ -->
            <div
              class="w-full bg-white dark:bg-gray-700 dark:text-gray-200 border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm rounded-lg focus:outline-none focus:ring focus:ring-yellow-200 cursor-pointer flex justify-between items-center"
              (click)="
                  isDisableInput
                    ? null
                    : (isOpenSelectClientId = !isOpenSelectClientId)
                ">
              <span ngClass="{{
                    !selectClientId?.name ? 'text-gray-600 dark:text-gray-400' : 'text-black dark:text-gray-200'
                  }}">
                {{ selectClientId?.name || "กรุณาเลือกลูกค้า" }}
              </span>
              <svg *ngIf="!isDisableInput" class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
            <!-- ตัวเลือกประเภทบัตรจอดรถ -->
            <div
              class="absolute left-0 right-0 mt-1 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg shadow z-10"
              *ngIf="isOpenSelectClientId">
              <div *ngFor="let item of optionClient"
                class="px-3 py-2 hover:bg-yellow-100 dark:hover:bg-gray-600 cursor-pointer text-gray-800 dark:text-gray-200"
                (click)="onClickSelectClientId(item)">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0 justify-center items-start w-full">
          <!--------- ประเภทรายรับชำระ ---------->
          <div class="relative flex item-center gap-2 w-full md:w-1/2">
            <div class="flex-1 relative">
              <p class="text-sm text-gray-700 dark:text-gray-300 pb-2">ประเภทรายรับชำระ</p>
              <!-- ปุ่มเลือกประเภทรายรับชำระ -->
              <div
                class="w-full bg-white dark:bg-gray-700 dark:text-gray-200 border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm rounded-lg focus:outline-none focus:ring focus:ring-yellow-200 cursor-pointer flex justify-between items-center"
                (click)="
                    isDisableInput
                      ? null
                      : (isOpenSelectFeeTypeId = !isOpenSelectFeeTypeId)
                  ">
                <span ngClass="{{
                      !selectFeeTypeId.label ? 'text-gray-600 dark:text-gray-400' : 'text-black dark:text-gray-200'
                    }}">
                  {{ selectFeeTypeId.label || "กรุณาเลือกประเภท" }}
                </span>
                <svg *ngIf="!isDisableInput" class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              <!-- ตัวเลือกประเภทรายรับชำระ -->
              <div
                class="absolute left-0 right-0 mt-1 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg shadow z-10"
                *ngIf="isOpenSelectFeeTypeId">
                <div *ngFor="let item of optionFeeTypeID"
                  class="px-3 py-2 hover:bg-yellow-100 dark:hover:bg-gray-600 cursor-pointer text-gray-800 dark:text-gray-200"
                  (click)="onClickSelectFeeTypeId(item)">
                  {{ item.label }}
                </div>
              </div>
            </div>
            <div *ngIf="isShowBank" class="flex-1 relative">
              <label class="block text-gray-700 dark:text-gray-300 text-sm mb-2">
                <span class="text-red-500">*</span>ประเภทบัญชีธนาคาร
              </label>
              <!-- ปุ่มเลือกประเภทบัญชีธนาคาร -->
              <div
                class="w-full bg-white dark:bg-gray-700 dark:text-gray-200 border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm rounded-lg focus:outline-none focus:ring focus:ring-yellow-200 cursor-pointer flex justify-between items-center"
                (click)="isOpenSelectAccountId = !isOpenSelectAccountId">
                <span class="text-gray-600 dark:text-gray-400">
                  {{ selectAccountId.label || "กรุณาเลือกประเภท" }}
                </span>
                <svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              <!-- ตัวเลือกประเภทบัญชีธนาคาร -->
              <div
                class="absolute left-0 right-0 mt-1 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg shadow z-10"
                *ngIf="isOpenSelectAccountId">
                <div *ngFor="let item of optionAccountBank"
                  class="px-3 py-2 hover:bg-yellow-100 dark:hover:bg-gray-600 cursor-pointer text-gray-800 dark:text-gray-200"
                  (click)="onClickSelectAccountBank(item)">
                  {{ item.label }}
                </div>
              </div>
            </div>
          </div>
          <!--------- จำนวนราคา ---------->
          <div class="w-full md:w-1/2">
            <div class="flex items-start gap-2 pb-2">
              <div class="flex items-center">
                <p class="text-sm text-gray-700 dark:text-gray-300">จำนวนราคา</p>
              </div>
            </div>
            <input type="number"
              class="w-full border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-yellow-200 rounded-lg"
              [ngClass]="{
                  'bg-gray-300 dark:bg-gray-600 bg-opacity-50 text-gray-400 dark:text-gray-500': isCheckboxFee,
                  'bg-white dark:bg-gray-700 dark:text-gray-200': !isCheckboxFee
                }" placeholder="กรุณากรอกจำนวนราคา" [(ngModel)]="cardAdvancePayloadModel.fee"
              [disabled]="isCheckboxFee || isDisableInput" max="1000" min="1" />
            <div class="flex items-center gap-2 pt-1" *ngIf="!isDisableInput">
              <input type="checkbox" [(ngModel)]="isCheckboxFee" />
              <p class="text-gray-600 dark:text-gray-400 text-sm">ไม่มีค่าใช้จ่าย</p>
            </div>
            <!-- แจ้งเตือน -->
          </div>

        </div>
        <div class="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0 justify-center items-start w-full">

          <!--------- ประเภทรายรับ ---------->
          <div class="relative w-full md:w-1/2">
            <p class="text-sm text-gray-700 dark:text-gray-300 pb-2">ประเภทรายรับ</p>
            <!-- ปุ่มเลือกประเภทรายรับ -->
            <div
              class="w-full bg-white dark:bg-gray-700 dark:text-gray-200 border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm rounded-lg focus:outline-none focus:ring focus:ring-yellow-200 cursor-pointer flex justify-between items-center"
              (click)="
                  isDisableInput ? null : (isOpenSelectFeeId = !isOpenSelectFeeId)
                ">
              <span ngClass="{{
                    !selectSubscription?.name ? 'text-gray-600 dark:text-gray-400' : 'text-black dark:text-gray-200'
                  }}">
                {{ selectSubscription?.name || "กรุณาเลือกประเภทรายรับ" }}
              </span>
              <svg *ngIf="!isDisableInput" class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
            <!-- ตัวเลือกประเภทรายรับ -->
            <div
              class="absolute left-0 right-0 mt-1 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg shadow z-10"
              *ngIf="isOpenSelectFeeId">
              <div *ngFor="let item of subscriptionData"
                class="px-3 py-2 hover:bg-yellow-100 dark:hover:bg-gray-600 cursor-pointer text-gray-800 dark:text-gray-200"
                (click)="onClickSelectFeeId(item)">
                {{ item.name }}
              </div>
            </div>
          </div>
          <!--------- รหัสใบแจ้งหนี้ ---------->
          <div class="w-full md:w-1/2">
            <p class="text-sm text-gray-700 dark:text-gray-300 pb-2">รหัสใบแจ้งหนี้</p>
            <input type="text"
              class="w-full bg-white dark:bg-gray-700 dark:text-gray-200 border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-yellow-200 rounded-lg"
              placeholder="กรุณากรอกรหัสใบแจ้งหนี้" [(ngModel)]="cardAdvancePayloadModel.invoiceNo"
              [disabled]="isDisableInput" (input)="
                  onChangeValidateNumber(
                    'invoice_no',
                    cardAdvancePayloadModel.invoiceNo
                  )
                " />
            <!-- แจ้งเตือน -->
          </div>
        </div>

      </div>
      <!-------------------------------------------- หมายเหตุ ------------------------------------>
      <div>
        <p class="text-sm text-gray-700 dark:text-gray-300 py-2">หมายเหตุ</p>
        <textarea
          class="w-full bg-white dark:bg-gray-700 dark:text-gray-200 border border-gray-300 dark:border-gray-600 flex-1 px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-yellow-200 rounded-lg"
          placeholder="กรุณากรอกหมายเหตุ" [(ngModel)]="cardAdvancePayloadModel.remark"
          [disabled]="isDisableInput"></textarea>
      </div>
      <div class="flex flex-col space-y-2">
        <!-------------------------------------------- รูปภาพ ------------------------------------>
        <div class="flex flex-col space-y-2 w-full" *ngIf="!isCheckboxFee && !isDisableInput">
          <p class="text-sm text-gray-700 dark:text-gray-300 pt-2">แนบรูปภาพ</p>
          <!-- Custom File Button -->
          <label for="fileInput"
            class="w-full cursor-pointer flex items-center justify-center px-4 py-5 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-100 dark:hover:bg-gray-600 gap-2 shadow">
            <label class="material-icons-outlined text-[14px]  group-hover:text-[#fad400]">
              upload
            </label>
            เลือกรูปภาพ
          </label>

          <!-- Hidden Input -->
          <input id="fileInput" type="file" class="hidden" (change)="onFileSelected($event)" />

          <!-- File Info -->
          <div *ngIf="fileName && !isCheckboxFee && !isDisableInput"
            class="flex items-center space-x-2 text-sm text-gray-700 dark:text-gray-300">
            <span class="font-medium">เลือกไฟล์แล้ว:</span>
            <span>{{ fileName }}</span>
            <button type="button" (click)="clearFile()" *ngIf="!isDisableInput"
              class="ml-2 px-2 py-1 bg-red-100 dark:bg-red-900 border border-red-200 dark:border-red-900 text-red-600 dark:text-red-400 rounded-lg hover:bg-red-200 dark:hover:bg-red-800">
              ลบ
            </button>
          </div>

          <!-- Preview Image -->
          <div *ngIf="base64 && base64.startsWith('data:image')" class="mt-2">
            <img [src]="base64" alt="Preview" class="max-h-40 rounded-lg border dark:border-gray-600" />
          </div>
        </div>
        <!-------------------------------------------- Tax ------------------------------------>
        <div class="my-4 w-full border-b border-gray-300 dark:border-gray-700 pb-4">
          <div class="flex justify-between items-center gap-2 mt-2 w-full" *ngIf="!isDisableInput">
            <label class="text-sm text-gray-700 dark:text-gray-300">ออกใบกำกับภาษี</label>
            <input type="checkbox" [(ngModel)]="isRequestTax"
              class="w-4 h-4 border-gray-300 dark:border-gray-600 rounded" />
          </div>
        </div>
        <div *ngIf="isRequestTax" class="w-full bg-white dark:bg-gray-800 mt-2 rounded-xl shadow-md p-1 space-y-3">
          <div
            class="flex items-center justify-between text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg px-4 py-3 transition duration-200 cursor-pointer"
            (click)="openTaxModal()">
            <div class="flex items-center gap-3">
              <i class="fa-solid fa-receipt text-blue-500 text-sm"></i>
              <span class="text-base">เพิ่มข้อมูลการออกใบกำกับภาษี</span>
            </div>
            <i class="fas fa-chevron-right text-gray-400"></i>
          </div>
        </div>
      </div>
    </div>
    <!--------------------------------------------- Body ------------------------------------->
    <div class="flex flex-col w-full bg-white dark:bg-gray-800 shadow py-2 m-2 rounded-xl">
      <div class="flex item-center gap-2 p-2" *ngIf="!isDisableInput">
        <button
          class="bg-yellow-300 flex justify-center items-center border border-yellow-300 px-4 py-2 rounded-md text-sm text-yellow-700 gap-2"
          (click)="openCreateModal()">
          <p class="">เพิ่ม</p>
        </button>

        <!-- ปุ่มเลือกไฟล์ -->
        <label for="excelInput"
          class="cursor-pointer bg-green-400 flex justify-center items-center border border-green-400 px-4 py-2 rounded-md text-sm text-white dark:text-green-800 gap-2">
          Import Excel
        </label>

        <input id="excelInput" type="file" class="hidden" accept=".xlsx, .xls" (change)="onFileChange($event)" />
        <button
          class="cursor-pointer bg-blue-300 dark:bg-blue-900 border-blue-100 dark:border-blue-900 text-gray-700 dark:text-blue-200 flex justify-center items-center border px-4 py-2 rounded-md text-sm gap-2"
          (click)="onExportToExcel()">
          ตัวอย่าง
        </button>
      </div>
      <div class="w-full h-0.5 bg-gray-200 dark:bg-gray-700 my-2" *ngIf="!isDisableInput"></div>
      <div class="overflow-x-auto shadow-lg rounded-2xl border border-gray-200 dark:border-gray-700">
        <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
          <thead class="bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 uppercase text-xs">
            <tr>
              <th class="px-4 py-4 text-left">No.</th>
              <th class="px-4 py-4 text-left">ชื่อ</th>
              <th class="px-4 py-4 text-left">ประเภท</th>
              <th class="px-4 py-4 text-left">เบอร์โทร</th>
              <th class="px-4 py-4 text-left">ป้ายทะเบียน</th>
              <th class="px-4 py-4 text-left">จังหวัด</th>
              <th class="px-4 py-4 text-left">ยี่ห้อ</th>
              <th class="px-4 py-4 text-left">รุ่น</th>
              <th class="px-4 py-4 text-left">สี</th>
              <th class="px-4 py-4 text-left">หมายเหตุ</th>
              <th class="px-4 py-4 text-left" *ngIf="!isDisableInput"></th>
            </tr>
          </thead>
          <tbody
            class="divide-y divide-gray-100 dark:divide-gray-700 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300">
            <tr *ngFor="let d of cardAdvanceDetailsModel; let i = index"
              class="hover:bg-gray-50 dark:hover:bg-gray-700">
              <td class="px-4 py-4">{{ i + 1 }}</td>
              <td class="px-4 py-4">{{ d.name }}</td>
              <td class="px-4 py-4">
                {{ d.type === 1 ? "เบอร์" : "ทะเบียน" }}
              </td>
              <td class="px-4 py-4">{{ d.phone }}</td>
              <td class="px-4 py-4">{{ d.plateNumber }}</td>
              <td class="px-4 py-4">{{ d.province }}</td>
              <td class="px-4 py-4">{{ d.brand }}</td>
              <td class="px-4 py-4">{{ d.model }}</td>
              <td class="px-4 py-4">{{ d.color }}</td>
              <td class="px-4 py-4">{{ d.remark }}</td>
              <td class="px-2 py-2" *ngIf="!isDisableInput">
                <button (click)="onClickDeleteCardAdvanceDetails(i)"
                  class="bg-red-500 bg-opacity-50 px-4 py-2 rounded-md text-sm text-white hover:text-red-700 dark:hover:text-red-300 hover:bg-red-400">
                  ลบ
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!--------------------------------------------- Modal ------------------------------------->
  <!---------------- Modal Tax -------------------->
  <div *ngIf="showTaxModal" class="fixed inset-0 z-10 flex items-start justify-center bg-black/50 pt-3 px-4">
    <div
      class="bg-white dark:bg-gray-800 rounded-xl p-6 w-full max-w-4xl max-h-[90vh] shadow-lg relative overflow-y-auto max-h-screen">
      <button (click)="closeTaxModal()"
        class="absolute top-4 right-4 text-gray-400 dark:text-gray-500 hover:text-red-500 dark:hover:text-red-400 text-2xl">
        <i class="fas fa-times"></i>
      </button>

      <div class=" ">
        <h2 class="text-2xl font-bold text-gray-800 dark:text-gray-200 mb-6 text-center">
          ขอใบกำกับภาษีแบบเต็มรูป
        </h2>
        <div class="w-4 h-4 absolute top-4 right-4" (click)="closeTaxModal()">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADQ0lEQVR4nO2d3WoTURSFRxDU1/BGb0REsWGyVuZ2P5WoF4pFsVS9sIj4CIqKaKE+V1FaOTQdJyTTpkk6+/ysBXNVzs7k+/Y502FOmKpS4gqAmwCeAfhMcp/kLoAt7/NKLePxeATgTWAYWAJ4HtieOYjkYwB/SB4vOD6a2bXBvkGiCYwAfFrEEMBfAI+qqroyNxDA0x7w3QI/m6a57vLNEkhgExidxzE0+szAuq5vkTxcYqAkrA8/HIdN09xuB5N8suTAUwm/RqPRjb6TKXTZ+XZBhmEpOgnJHxcZrJmwcud3+X1vi5D8etECmgnVSp3fYfelLUTy1SpFSp4JzYqd3+H2si02mUzurVqoRAnNmvDDEZjPFJ3eNKwjoYjlyNZYdjrHbl/htazmPhOaDXR+GN97Qxv+sOoFOfeZYBvo/AD/XDaS4Ai/+4GS4AT/NJJQ+cHvnkCpEswbfskSLBb4JUqw2OCXJMFihV+CBIsdfs4SLBX4OUqw1ODnJMFShZ+DBEsdfsoSLBf4KUqw3OCnJMFyhZ+CBMsdfswSrBT4MUqw0uDHJMFKhR+DBCsdvqcEE3w/CSb4fhJM8P0kmOD7STDB95Nggu+7zxLaz+o7E6jOT1MCBP9/hpYg+I4SIPh+EiD4fhIg+H4SIPh+EiD4rr9GPPbe/FU0fEqCP3xKgj98SoI/fEqCP3xKgj98SoI/fEqCHsi4ZpOPES2CHXhJ5TKe4ZokLJfLfIBuknB2hti9YJKwOENuHTFJmI3Hvh2ThJN4bpqy0iXEsGPNSpUQA/xiJcQEvzgJMUIvRkLM8LOXkAL8bCWkBD87CSnCz0ZCyvCTl5AD/GQl5AQ/OQk5wk9GQs7wo5dQAvxoJZQEPzoJJcKPRkLJ8N0lCL6jBMF3lCD4jhL0IjfnF7kB+CD4w0gguTdTFMCWlp3Bf0L7sC1I8p06f/DX2b5ti5H8LfjDSgBw0BYiua9lZ9jlKPBriwDYUecPOxMAvG4LjMfjuySPBH8wCUeTyeTOTIHwjnMtO4MtRy/mBjdNc3UqoW8mvF94A6EskrDX1/kAtgPrqi9haoRrQrhtDlfq8O8SgPu9A5SFqev6wZTdwZTlztyyo1Tu+QfEI7plG6RekAAAAABJRU5ErkJggg=="
            alt="delete-sign" />
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm text-gray-700 dark:text-gray-300">
        <!-- ประเภท -->
        <div class="col-span-full">
          <label class="block font-medium text-base">ประเภท</label>
          <select
            class="w-full px-4 py-2 border dark:border-gray-600 rounded-lg shadow bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
            [(ngModel)]="selectedTaxType" (ngModelChange)="filterAddressByTaxType()" [disabled]="isDisableInput">
            <option value="1">บุคคลธรรมดา</option>
            <option value="2">นิติบุคคล</option>
          </select>
        </div>

        <!-- เลือกที่อยู่ -->
        <div class="col-span-full" *ngIf="showSelectAddress">
          <div
            class="w-full p-4 border dark:border-gray-600 rounded-xl shadow-sm bg-white dark:bg-gray-700 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-600 transition flex justify-between items-start"
            (click)="('')">
            <div class="flex items-start gap-3">
              <span class="text-orange-500 text-xl mt-1">📍</span>
              <div class="flex flex-col">
                <div class="font-semibold text-base text-gray-800 dark:text-gray-200">
                  {{ selectedAddress?.full_name }}
                  <span class="text-sm text-gray-400 dark:text-gray-500 ml-2">
                    {{ selectedAddress?.phone }}
                  </span>
                </div>
                <div class="text-sm mt-1 leading-snug text-gray-700 dark:text-gray-300">
                  {{ selectedAddress?.company_name }}
                  {{ selectedAddress?.address }}
                  {{ selectedAddress?.sub_district }}
                  {{ selectedAddress?.district }}
                  {{ selectedAddress?.provinces }}
                  {{ selectedAddress?.zip_code }}
                </div>
              </div>
            </div>
            <i class="fas fa-chevron-right text-gray-400 dark:text-gray-500 mt-1"></i>
          </div>
        </div>
        <!-- ภาษี/ที่อยู่ -->
        <div class="sm:col-span-2">
          <label>เลขประจำตัวผู้เสียภาษี</label>
          <div class="flex gap-2">
            <input [(ngModel)]="taxId" type="text"
              class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
              [disabled]="isDisableInput" />
            <button *ngIf="selectedTaxType === '2'" type="button"
              class="px-4 py-2 bg-red-500 text-white text-sm rounded hover:bg-green-600 dark:hover:bg-green-700 whitespace-nowrap"
              (click)="getAddressByTaxId()">
              ค้นหา
            </button>
          </div>
        </div>
        <!-- สำนักงานใหญ่ toggle -->
        <div *ngIf="selectedTaxType === '2' || isDisableInput"
          class="flex items-center justify-between col-span-full border-b dark:border-gray-600 py-2">
          <span class="text-base text-gray-800 dark:text-gray-200">สำนักงานใหญ่</span>
          <label class="flex items-center gap-2 cursor-pointer text-gray-800 dark:text-gray-200">
            <input type="checkbox" class="w-5 h-5 text-green-600 accent-green-600 focus:ring-green-500 rounded"
              [(ngModel)]="mainOffice" [disabled]="isDisableInput" />
            สำนักงานใหญ่
          </label>
        </div>

        <!-- ข้อมูลทั่วไป -->
        <div>
          <label>ชื่อบริษัท / ผู้เสียภาษี</label>
          <input [(ngModel)]="taxName" type="text"
            class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
            [disabled]="isDisableInput" />
        </div>

        <div>
          <label>เบอร์โทรศัพท์</label>
          <input [(ngModel)]="tax_phone" type="text" maxlength="10" pattern="[0-9]*"
            class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
            [disabled]="isDisableInput" />
        </div>

        <div class="sm:col-span-2">
          <label>อีเมล</label>
          <input [(ngModel)]="email" type="text"
            class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
            [disabled]="isDisableInput" />
        </div>

        <!-- ชื่อสาขา -->
        <div *ngIf="
            (!mainOffice && selectedTaxType === '2') ||
            (!mainOffice && isDisableInput)
          ">
          <label>ชื่อสาขา</label>
          <input [(ngModel)]="branchName" type="text"
            class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
            [disabled]="isDisableInput" />
        </div>

        <div *ngIf="
            (!mainOffice && selectedTaxType === '2') ||
            (!mainOffice && isDisableInput)
          ">
          <label>รหัสประจำสาขา</label>
          <input [(ngModel)]="branchNo" type="text"
            class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
            [disabled]="isDisableInput" />
        </div>

        <div class="sm:col-span-2">
          <label>ที่อยู่</label>
          <input [(ngModel)]="address" type="text"
            class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
            [disabled]="isDisableInput" />
        </div>

        <!-- จังหวัด -->
        <div>
          <label>จังหวัด</label>
          <select [(ngModel)]="selectedProvinceId" (change)="onProvinceChange()"
            class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
            *ngIf="!isDisableInput">
            <option [value]="null" disabled selected>เลือกจังหวัด</option>
            <option *ngFor="let province of provincess" [value]="province.id">
              {{ province.name_th }}
            </option>
          </select>
          <div *ngIf="isDisableInput">
            <input [(ngModel)]="province_name" type="text"
              class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
              [disabled]="isDisableInput" />
          </div>
        </div>

        <!-- อำเภอ -->
        <div>
          <label>อำเภอ</label>
          <select [(ngModel)]="selectedAmphureId" (change)="onAmphureChange()"
            class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
            *ngIf="!isDisableInput">
            <option [value]="null" disabled selected>เลือกอำเภอ</option>
            <option *ngFor="let amphure of filteredAmphures" [value]="amphure.id">
              {{ amphure.name_th }}
            </option>
          </select>
          <div *ngIf="isDisableInput">
            <input [(ngModel)]="amphure_name" type="text"
              class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
              [disabled]="isDisableInput" />
          </div>
        </div>

        <!-- ตำบล -->
        <div>
          <label>ตำบล</label>
          <select [(ngModel)]="selectedTambonId" (change)="onTambonsChange()"
            class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
            *ngIf="!isDisableInput">
            <option [value]="null" disabled selected>เลือกตำบล</option>
            <option *ngFor="let tambon of filteredTambons" [value]="tambon.id">
              {{ tambon.name_th }}
            </option>
          </select>

          <div *ngIf="isDisableInput">
            <input [(ngModel)]="tambon_name" type="text"
              class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
              [disabled]="isDisableInput" />
          </div>
        </div>

        <!-- รหัสไปรษณีย์ -->
        <div>
          <label>เลขไปรษณีย์</label>
          <input type="text" [(ngModel)]="zipcode" readonly
            class="w-full border dark:border-gray-600 px-3 py-2 rounded-md bg-gray-100 dark:bg-gray-600 text-gray-800 dark:text-gray-200"
            [disabled]="isDisableInput" />
        </div>
      </div>

      <div class="mt-6 text-center" *ngIf="!isDisableInput">
        <button class="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition" (click)="summit()">
          บันทึก
        </button>
      </div>
    </div>
  </div>

  <!---------------- Modal Create ----------------->
  <div class="fixed inset-0" *ngIf="showCreateModal">
    <!--------- Background ---------->
    <div class="fixed inset-0 bg-black/75 transition-opacity"></div>

    <!--------- Modal Container ---------->
    <div class="absolute inset-0 top-0 left-0 opacity-100 transition-opacity flex justify-center items-center">
      <!--------- Modal Content ---------->
      <div class="flex flex-col w-1/2 bg-white shadow py-2 m-2 rounded-xl relative">
        <!----- Header----->
        <div class="border-b border-gray-300 px-2 pt-2 relative">
          <h2 class="text-2xl font-bold text-gray-800 mb-6 text-center">
            เพิ่มข้อมูลบัตรจอดรถ
          </h2>
          <div class="w-4 h-4 absolute top-2 right-4" (click)="closeCreateModal()">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACB0lEQVR4nO2dS07DMBgGcyZYlLs49ncM2MGSy4J6A1BVKhWUlqSP/A/PSN11Uc8kcmtbzTAAAAAAAAAAAABALGqtL+M4bobkjOO42Y118ESt9a219lVr3Up6GpIi6bG19vkz1vfBk/zDK2sEHck/Guu7K/lZI2hCvnmEU/KzRdAZ+WYRdpPQuQ90HCHyxDzuJ9ztzLGuNzGXUh5qrR9zI0S8EzTjyje90DJHkHf5mSMoivyMERRNfqYIiio/QwRFlx85grLIjxhB2eRHiqCs8iNEUHb5niOoF/keI6g3+Z4iqFf5HiKod/mWEYR8uwhCvl0EId8ugpBvF0HIt4sg5NtFEPLtIgj5dhGEfNOzONsl70X+He6EhnzfESry7SJU5NtFqMi3i1CRf1u04Kvm1O8EWFF+I4K9/EYEe/mNCPbyGxGWM7IUYYcuWFjzcOQlBbpiVZMIV6IbLCkT4UJ0w/V8IixEd9hMIcJM7rmTVYhwnjW2EQsRpllzD7cQ4TcWG+iFCHssTy+U3iN4ODpSeo3gQX63ETzJ7y6CR/ndRPAsP32ECPLTRogkP12EiPLTRIgsP3yEDPLDRsgkP1yEjPLDRMgsP0QE/rq4TY113WcKtNaeM8tfeCe8DhacipBF/swINvJPRcgm/58ItvL/Rsgq/0QEH/IP8BAfAAAAAAAAAAAAGDzzDal0NeBLEXg6AAAAAElFTkSuQmCC"
              alt="delete-sign" />
          </div>
        </div>
        <!----- Body ------>
        <div class="py-4 pt-4 px-4 space-y-4">
          <!-- ชื่อ -->
          <div>
            <p class="text-sm text-gray-700 pb-2">ชื่อลูกค้า</p>
            <input type="text"
              class="w-full border px-3 py-2 rounded-md focus:outline-none focus:ring focus:ring-yellow-200 bg-gray-50"
              [(ngModel)]="cardAdvanceDetailsCreateModel.name" placeholder="กรุณากรอกชื่อ" (input)="
                onChangeValidateText(
                  'create_name',
                  cardAdvanceDetailsCreateModel.name
                )
              " />
            <!-- แจ้งเตือน -->
            <div>
              <p class="text-red-600 text-xs mt-1" *ngIf="
                  isTextValid.where === 'create_name' && !isTextValid.result
                ">
                กรุณากรอกตัวอักษรให้ถูกต้อง
              </p>
            </div>
          </div>
          <!-- ประเภท -->
          <div class="relative">
            <p class="text-sm text-gray-700 pb-2">ประเภท</p>
            <!-- ปุ่มเลือกประเภท -->
            <div
              class="w-full bg-white border border-gray-300 flex-1 px-3 py-2 text-sm bg-gray-50 rounded-lg focus:outline-none focus:ring focus:ring-yellow-200 cursor-pointer flex justify-between items-center"
              (click)="
                isOpenSelectTypeCreateMember = !isOpenSelectTypeCreateMember
              ">
              <span class="text-gray-600">
                {{ selectTypeCreateMember.name || "กรุณาเลือกประเภท" }}
              </span>
              <svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
            <!-- ตัวเลือกประเภท -->
            <div class="absolute left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow z-10"
              *ngIf="isOpenSelectTypeCreateMember">
              <div *ngFor="let item of optionTypeCreateMember" class="px-3 py-2 hover:bg-yellow-100 cursor-pointer"
                (click)="onClickSelectTypeCreateMember(item)">
                {{ item.name }}
              </div>
            </div>
          </div>
          <!-- เบอร์โทร -->
          <div *ngIf="cardAdvanceDetailsCreateModel.type === 1">
            <p class="text-sm text-gray-700 pb-2">เบอร์โทร</p>
            <input type="text"
              class="w-full border px-3 py-2 rounded-md focus:outline-none focus:ring focus:ring-yellow-200 bg-gray-50"
              [(ngModel)]="cardAdvanceDetailsCreateModel.phone" placeholder="กรุณากรอกชื่อ" (input)="
                onChangeValidateNumber(
                  'create_phone',
                  cardAdvanceDetailsCreateModel.phone
                )
              " />
            <!-- แจ้งเตือน -->
            <div>
              <p class="text-red-600 text-xs mt-1" *ngIf="
                  isNumberValid.where === 'create_phone' &&
                  !isNumberValid.result
                ">
                กรุณากรอกตัวอักษรให้ถูกต้อง
              </p>
            </div>
          </div>
          <!-- ทะเบียน -->
          <div *ngIf="cardAdvanceDetailsCreateModel.type === 2">
            <p class="text-sm text-gray-700 pb-2">ทะเบียน</p>
            <input type="text"
              class="w-full border px-3 py-2 rounded-md focus:outline-none focus:ring focus:ring-yellow-200 bg-gray-50"
              [(ngModel)]="cardAdvanceDetailsCreateModel.plateNumber" placeholder="กรุณากรอกทะเบียน" (input)="
                onChangeValidateTextNumber(
                  'create_plateNumber',
                  cardAdvanceDetailsCreateModel.plateNumber
                )
              " />
            <!-- แจ้งเตือน -->
            <div>
              <p class="text-red-600 text-xs mt-1" *ngIf="
                  isTextNumberValid.where === 'create_plateNumber' &&
                  !isTextNumberValid.result
                ">
                กรุณากรอกตัวอักษรให้ถูกต้อง
              </p>
            </div>
          </div>
          <div *ngIf="cardAdvanceDetailsCreateModel.type === 2" class="space-y-4">
            <!-- จังหวัด -->
            <div>
              <p class="text-sm text-gray-700 pb-2">จังหวัด</p>
              <select [(ngModel)]="selectedCreateProvinceId" (change)="onProvinceCreateChange()"
                class="w-full border px-3 py-2 rounded-md text-gray-600 focus:outline-none focus:ring focus:ring-yellow-200 bg-gray-50">
                <option [value]="null" disabled selected>เลือกจังหวัด</option>
                <option *ngFor="let province of provincess" [value]="province.id">
                  {{ province.name_th }}
                </option>
              </select>
              <!-- แจ้งเตือน -->
              <div>
                <p class="text-red-600 text-xs mt-1" *ngIf="isTextValid.where === '' && !isTextValid.result">
                  กรุณากรอกตัวอักษรให้ถูกต้อง
                </p>
              </div>
            </div>
            <!-- ยี่ห้อ -->
            <div>
              <p class="text-sm text-gray-700 pb-2">ยี่ห้อ</p>
              <input type="text"
                class="w-full border px-3 py-2 rounded-md focus:outline-none focus:ring focus:ring-yellow-200 bg-gray-50"
                [(ngModel)]="cardAdvanceDetailsCreateModel.brand" placeholder="กรุณากรอกชื่อ" />
              <!-- แจ้งเตือน -->
            </div>
            <!-- รุ่น -->
            <div>
              <p class="text-sm text-gray-700 pb-2">รุ่น</p>
              <input type="text"
                class="w-full border px-3 py-2 rounded-md focus:outline-none focus:ring focus:ring-yellow-200 bg-gray-50"
                [(ngModel)]="cardAdvanceDetailsCreateModel.model" placeholder="กรุณากรอกชื่อ" />
              <!-- แจ้งเตือน -->
            </div>
            <!-- สี -->
            <div>
              <p class="text-sm text-gray-700 pb-2">สี</p>
              <input type="text"
                class="w-full border px-3 py-2 rounded-md focus:outline-none focus:ring focus:ring-yellow-200 bg-gray-50"
                [(ngModel)]="cardAdvanceDetailsCreateModel.color" placeholder="กรุณากรอกชื่อ" />
              <!-- แจ้งเตือน -->
            </div>
          </div>
          <!-- หมายเหตุ -->
          <div>
            <p class="text-sm text-gray-700 pb-2">หมายเหตุ</p>
            <textarea
              class="w-full bg-white border border-gray-300 flex-1 px-3 py-2 text-sm bg-gray-50 focus:outline-none focus:ring focus:ring-yellow-200 rounded-lg"
              placeholder="กรุณากรอกหมายเหตุ" [(ngModel)]="cardAdvanceDetailsCreateModel.remark"></textarea>
          </div>
        </div>
        <!----- Button----->
        <div class="flex justify-end item-center gap-2 p-2 border-t border-gray-300">
          <button
            class="bg-yellow-300 flex justify-center items-center border border-yellow-300 px-4 py-2 rounded-md text-sm text-gray-700 gap-2"
            (click)="closeCreateModal()">
            <p class="text-white">ปิด</p>
          </button>
          <button
            class="bg-green-500 flex justify-center items-center border border-gray-300 px-4 py-2 rounded-md text-sm text-gray-700 gap-2"
            [ngClass]="{
              'bg-gray-300 cursor-not-allowed':
                !isTextValid.result ||
                !isNumberValid.result ||
                !isTextNumberValid.result ||
                !isSpecialValid.result,
              'bg-green-500 hover:bg-green-600 cursor-pointer':
                isTextValid.result &&
                isNumberValid.result &&
                isTextNumberValid.result &&
                isSpecialValid.result
            }" (click)="onClickSaveCardAdvanceDetails()" [disabled]="
              !isTextValid.result ||
              !isNumberValid.result ||
              !isTextNumberValid.result ||
              !isSpecialValid.result
            ">
            <p class="text-white">บันทึก</p>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!----------- Modal Selected Site ID -------------------->
  <app-modal-provider-site [(showModal)]="showSelectProviderModal" [dataList]="allProviders"
    (itemSelected)="selectProvider($event)"></app-modal-provider-site>
</div>